import axios from 'axios';
import APIS from '../../apis/activity';
import qs from 'qs';
import {
    callbackHandler,
} from '../callbackHandler';

export default {
    state: {},
    mutations: {},
    getters: {},
    actions: {
        getDEConsultReceiveCoupon(context, params) {
            return axios.get(APIS.doubleElevenReceiveCoupon, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenReceiveCoupon, res);
                return res.data;
            })
        },
        getDEConsultPackages(context, params) {
            return axios.get(APIS.doubleElevenConsultPackages, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenConsultPackages, res);
                return res.data;
            })
        },
        getDEScalePricePlan(context, params) {
            return axios.get(APIS.doubleElevenScalePricePlan, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenScalePricePlan, res);
                return res.data;
            })
        },
        getDEScaleRankList(context, params) {
            return axios.get(APIS.doubleElevenScaleRankList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenScaleRankList, res);
                return res.data;
            })
        },
        getDEScaleCombos(context, params) {
            return axios.get(APIS.doubleElevenScaleCombos, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenScaleCombos, res);
                return res.data;
            })
        },
        getDEScalePackages(context, params) {
            return axios.get(APIS.doubleElevenScalePackages, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.doubleElevenScalePackages, res);
                return res.data;
            })
        },

        // htpUploadImage(context, { env, params, callback } = {}) {
        //     return axios.post(APIS.htpUploadImage, params)
        //         .then(function (res) {
        //             callbackHandler(APIS.htpUploadImage, res);
        //             return res.data;
        //         })
        // },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js